import { Fragment } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { queryClient } from '@core/queryClient';
import { LegalDocPage, LEGAL_DOCS } from '@features/legal';

/**
 * Entry for the legal host (legal.meitre.com).
 * Tenant-less, neutral Meitre brand — corporate legal documents, not a
 * restaurant. Self-contained: content is fetched from /legal/{lang}.json, so no
 * TenantProvider/TenantGuard and no i18n namespaces.
 *
 * Routes (each with an optional /:lang suffix → e.g. /privacy-policy/es):
 *   /privacy-policy, /terms-and-conditions, /terms-service
 *   *  → /privacy-policy
 */
export function LegalApp() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          {LEGAL_DOCS.map((doc) => (
            <Fragment key={doc}>
              <Route path={`/${doc}`} element={<LegalDocPage doc={doc} />} />
              <Route path={`/${doc}/:lang`} element={<LegalDocPage doc={doc} />} />
            </Fragment>
          ))}
          <Route path="*" element={<Navigate to="/privacy-policy" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default LegalApp;
